module.exports = __webpack_public_path__ + "static/media/wait.97a0e841.svg";